import * as React from 'react';
import styled from 'styled-components/macro';
import { Modal } from 'lib/components';
import { Button } from 'react-covideo-common';
import { IoMdClose } from 'react-icons/io';
import { useTranslation } from 'react-i18next';

const ModalItem = styled.div`
  box-sizing: border-box;
  width: 600px;
  padding: 32px;
  min-height: 208px;
  background-color: ${({ theme }) => theme.colors.white[100]};
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  height: 24px;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  padding: 0;
  color: ${({ theme }) => theme.colors.black[100]};
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.black[100]};
  margin: 0;
`;

const CloseButtonWrapper = styled.label`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  color: ${({ theme }) => theme.colors.black[100]};
  &:hover {
    cursor: pointer;
  }
`;

const Content = styled.div`
  margin-top: 32px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.black[100]};
`;

const ButtonsWrapper = styled.section`
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;
  gap: 8px;
`;

type Props = {
  onClickPrimaryButton: () => void;
  onClickSecondaryButton: () => void;
  handleModalClose: () => void;
};

export const ModalDeleteQuotePrompt = ({
  onClickSecondaryButton,
  onClickPrimaryButton,
  handleModalClose,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Modal disableFullScreen={true} style={{ position: 'fixed' }}>
      <ModalItem>
        <Header>
          <Title>{t('Delete Quote Data')}</Title>
          <CloseButtonWrapper>
            <IoMdClose size={24} onClick={handleModalClose} />
          </CloseButtonWrapper>
        </Header>
        <Content>
          {t('Are you sure you want to delete all data from the Quote?')}
        </Content>
        <ButtonsWrapper>
          <Button
            variant='secondary'
            text={t('No, Keep Quote')}
            onClick={onClickSecondaryButton}
          />
          <Button
            variant='red'
            text={t('Yes, Delete Quote')}
            onClick={onClickPrimaryButton}
          />
        </ButtonsWrapper>
      </ModalItem>
    </Modal>
  );
};
